import { useFormik } from "formik";
import React, { useState } from "react";
import CustomToggleSwitch from "../../../../components/common/CustomToggle";
import CustomTable from "../../../../components/common/CustomTable";
import CustomModal from "../../../../components/common/Modal";
import { useToggleState } from "../../../../Hooks/useToggleState";
import CustomDropdown from "../../../../components/common/CustomDropdown/CustomDropdown";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import {
   addSingleCustomerChildAsync,
   fetchSingleCustomerMasterAsync,
   updateSingleCustomerChildAsync,
} from "../../../../redux/features/customerMaster";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import * as yup from "yup";
import { BsPencilSquare } from "react-icons/bs";

const Location = ({ locationList, locationData }) => {
   const dispatch = useDispatch();
   const params = useParams();

   const [action, setAction] = useState("");
   const [initialState, setInitialState] = useState({
      id: "",
      location: "",
      locationMasterId: "",
      locationValues: [{ label: "", value: "" }],
   });

   const [isChecked, setIsChecked] = useState({}); // State to manage toggle

   const [isModalVisible, handleShowModal, handleCloseModal] = useToggleState();
   const [isImageModalVisible, handleShowImageModal, handleCloseImageModal] =
      useToggleState();
   const [imageUrl, setImageUrl] = useState(null);

   const formik = useFormik({
      initialValues: initialState,
      validationSchema: yup.object().shape({
         location: yup.string().required("Location is required!"),
      }),
      onSubmit: action === "add" ? handleLocationAdd : handleLocationUpdate,
   });

   const {
      touched,
      errors,
      values,
      getFieldProps,
      handleSubmit,
      resetForm,
      setFieldValue,
      setValues,
   } = formik;

   const toggleSwitch = () => {};

   const columns = [
      {
         name: "Location",
         selector: (row) => <div>{row.name}</div>,
         sortable: true,
      },

      {
         name: "Action",
         width: "9rem",
         selector: (row) => row.action,
      },
   ];

   const data = locationList?.map?.((item) => ({
      ...item,
      action: (
         <div className="d-flex align-items-center">
            <button
               className="btn"
               onClick={() => {
                  setAction("edit");
                  setValues({
                     id: item?.id,
                     location: "",
                     locationMasterId: item?.pivot?.location_master_id,
                     locationValues: locationData?.filter?.(
                        (loc) => loc?.value === item?.pivot?.location_master_id
                     ),
                  });
                  handleShowModal();
               }}
            >
               <BsPencilSquare
                  className="text-primary"
                  style={{ height: "1.5rem", width: "1.5rem" }}
               />
            </button>
            <CustomToggleSwitch
               checked={isChecked}
               onChange={toggleSwitch}
               id="csutomer6"
            />
         </div>
      ),
   }));

   function handleLocationUpdate(formdata) {
      const newData = new FormData();

      newData.append("customer_master_id", params?.id);
      newData.append("location_id", formdata?.location);
      newData.append(
         "location_master_id[]",
         JSON.stringify([formdata?.locationMasterId])
      );
      newData.append("_method", "PATCH");
      newData.append("model_id", 6);
      newData.append("action_id", 2);

      dispatch(backdropLoadingAction(true));

      dispatch(
         updateSingleCustomerChildAsync({
            data: newData,
            err: () => {
               toast.error("Something went wrong !");
               dispatch(backdropLoadingAction(false));
            },
            done: () => {
               toast.success("Record updated successfully !");
               handleCloseModal();
               dispatch(
                  fetchSingleCustomerMasterAsync({
                     id: params?.id,
                     err: () => {
                        dispatch(backdropLoadingAction(false));
                     },
                     done: () => {
                        dispatch(backdropLoadingAction(false));
                        resetForm();
                     },
                  })
               );
            },
         })
      );
   }

   function handleLocationAdd(formdata) {
      const newData = new FormData();

      newData.append("customer_master_id", params?.id);
      newData.append("location_master_id[]", JSON.stringify([formdata?.location]));
      newData.append("model_id", 6);
      newData.append("action_id", 1);

      dispatch(backdropLoadingAction(true));

      dispatch(
         addSingleCustomerChildAsync({
            data: newData,
            err: () => {
               toast.error("Something went wrong !");
               dispatch(backdropLoadingAction(false));
            },
            done: () => {
               toast.success("Record added successfully !");
               handleCloseModal();
               resetForm();
               dispatch(
                  fetchSingleCustomerMasterAsync({
                     id: params?.id,
                     err: () => {
                        dispatch(backdropLoadingAction(false));
                     },
                     done: () => {
                        dispatch(backdropLoadingAction(false));
                     },
                  })
               );
            },
         })
      );
   }

   return (
      <>
         <CustomModal
            showModal={isModalVisible}
            handleCloseModal={() => {
               resetForm();
               handleCloseModal();
            }}
            modalSize="modal-md"
            title="Location"
            onSubmit={handleSubmit}
            child={
               <>
                  <div className="col-lg-12" style={{ minHeight: 300 }}>
                     <CustomDropdown
                        optionData={locationData}
                        label="Location"
                        id=""
                        values={values?.locationValues}
                        onChange={(values) => {
                           setFieldValue("location", values?.[0]?.value);
                           setFieldValue("locationValues", values);
                        }}
                        errors={touched?.location && errors?.location}
                        message={errors?.location}
                     />
                  </div>
               </>
            }
         />

         <div className="d-flex w-100 mb-2 justify-content-between align-items-end">
            <label className="text-bold">Locations</label>
            <div className="">
               <button
                  type="button"
                  className="btn btn-primary float-right"
                  onClick={() => {
                     setAction("add");
                     setInitialState({
                        id: "",
                        location: "",
                     });
                     handleShowModal();
                  }}
               >
                  <i className="fas fa-plus"></i> Add More
               </button>
            </div>
         </div>

         <CustomTable columns={columns} data={data} />
      </>
   );
};

export default Location;
